import palette from './palette.mjs';

const { main: primary, light } = palette.primary;

export default {
  MuiFab: {
    root: {
      width: 40,
      height: 40,
      borderRadius: 8,
      boxShadow: 'none !important',
      color: '#141414',
      '&.Mui-disabled': {
        backgroundColor: primary,
        color: '#141414',
        opacity: '0.4',
      },
    },
    primary: {
      color: '#141414',
      '&:hover': { backgroundColor: light },
    },
    sizeSmall: {
      width: 32,
      height: 32,
      minHeight: 32,
      '& .MuiSvgIcon-root': {
        fontSize: 16,
      },
    },
    sizeMedium: {
      width: 36,
      height: 36,
    },
  },
};
